module.exports = __webpack_public_path__ + "img/instruction-open-file.dfe3c485.png";